import { Formik } from "formik";
import { FC, useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useIntl } from "react-intl";
import * as Yup from "yup";
import { AppContext } from "../../../appContext/AppContext";
import FormThemMoi from "./components/FormThemMoi";
import "./ThemMoiPhieuXuat.scss";
import { generateForm, generateInitValues, generateValidationSchema, handleCaculateTotalAmount } from "../../../utils/AppFunction";
import {getDetailsPhieuXuatKho, updatePhieuXuatKho} from "../../../phan-he-xuat-kho/services/servicesXuatKho";
import { initialPhieuXuat, PhieuXuat } from "../../../phan-he-xuat-kho/models/XuatKhoModel";
import BackButton from "../../../component/BackButton";
import ModelHeader from "../../../component/ModelHeader";
import {toast} from "react-toastify";
import {createPhieuHoanTra} from "../../services/TongHopPhieuServices";
import {RESPONSE_CODE_SUCCESS} from "../../../category-personnel/const/PersonnelConst";
import {PHIEU_TONGHOP_DS} from "../../Constant";
import {formatDateDTO} from "../../../utils/FormatUtils";

type Props = {
  MATE_WH_DEFAUILT?: any;
  show?: boolean;
  type?: any;
  title?: any;
  onHide: () => void;
  dataEdit: PhieuXuat;
  warehouseId: number;
  warehouseExportType?: any
};

const DialogThemMoiPhieuXuatKho: FC<Props> = (props) => {
  const { show, onHide, title, type, warehouseExportType, dataEdit, warehouseId, MATE_WH_DEFAUILT = [] } = props;
  const intl = useIntl();
  const { setIsLoading } = useContext(AppContext);
  const [listJsonGeneratePhieuXuat, setListJsonGeneratePhieuXuat] = useState<any>([]);
  const [thongTinPhieuXuat, setThongTinPhieuXuat] = useState<PhieuXuat>(initialPhieuXuat);
  const [validationSchemaSelected, setValidationSchemaSelected] = useState<any>(Yup.object({}));
  const validationSchema = {

  };
  const [isChangeRowData, setIsChangeRowData] = useState<boolean>(false);
  useEffect(() => {
    if (dataEdit.id) {
      updatePageData();
    };
  }, [dataEdit.id]);

  useEffect(() => {
    warehouseExportType.modelId && getListform();
  }, [warehouseExportType.modelId]);
  const getListform = async () => {
    let data = await generateForm( warehouseExportType?.code === PHIEU_TONGHOP_DS.PLTTTT.code ? "tonghopduyetphieutonghoplinhbututruc" : warehouseExportType.modelId, setIsLoading)
    setListJsonGeneratePhieuXuat(data)
  }
  useEffect(() => {
    const wareHouseKey = warehouseId as keyof typeof MATE_WH_DEFAUILT;
    setThongTinPhieuXuat({
      ...thongTinPhieuXuat,
      phieuXuatKhoAdd: {
        ...thongTinPhieuXuat?.phieuXuatKhoAdd,
        ...MATE_WH_DEFAUILT[wareHouseKey]
      }
    })
  }, [warehouseId]);

  useEffect(() => {
    const validationSchemaKey = warehouseExportType.modelId as keyof typeof validationSchema;
    setValidationSchemaSelected(validationSchema?.[validationSchemaKey]);
  }, [warehouseExportType.modelId]);

  const handleFormSubmit = async (values: any) => {
    if(!dataEdit.id) return;
    if (values?.dsThuoc.find((x:any) => Number(x.totalQuantity) > Number(x.requireQuantity))) {
      toast.warning('Số lượng duyệt không được lớn hơn số lượng yêu cầu');
      return;
    }
    try {
      setIsLoading(true)
      const data = {
        slipDto: values.phieuXuatKhoAdd,
        lstItem: values?.dsThuoc
      };
      let res =
        await updatePhieuXuatKho(dataEdit.id, data, warehouseExportType.modelId);
      if (res?.data?.code === RESPONSE_CODE_SUCCESS) {
        toast.success("Thành công");
        setIsChangeRowData(false);
      }
    } catch (error) {
      console.error("ERR", error)
    } finally {
      setIsLoading(false)
    }
  };

  const updatePageData = async () => {
    try {
      // setIsLoading(true);
      const { data } = await getDetailsPhieuXuatKho(dataEdit.id, warehouseExportType.modelId);
      setThongTinPhieuXuat({
        ...thongTinPhieuXuat,
        phieuXuatKhoAdd: {
          ...dataEdit,
          ...data.data,
          exportDate: data.data?.exportDate || formatDateDTO(new Date()),
          id: dataEdit.id || data.data?.id,
        }
      });

    } catch (error) {
      console.error(error);
    } finally {
      // setIsLoading(false);
    }
  };

  return (
    <div>
      <Modal
        centered
        show={show}
        // onHide={onHide}
        size="xl"
        fullscreen
        className="page-full spaces h-calc-vh-50"
      >
        <ModelHeader onHide={onHide} title={title} />
        <Modal.Body className="spaces p-0 mt-1 bg-white">
          <Formik<any>
            enableReinitialize
            initialValues={{ ...thongTinPhieuXuat }}
            validationSchema={validationSchemaSelected}
            // initialValues={generateInitValues(listJsonGeneratePhieuXuat, 'phieuXuatKhoAdd')}
            // validationSchema={generateValidationSchema(listJsonGeneratePhieuXuat, "phieuXuatKhoAdd")}
            onSubmit={handleFormSubmit}
          >
            <FormThemMoi
              type={type}
              listJsonGeneratePhieuXuat={listJsonGeneratePhieuXuat}
              isReload={show} onHide={onHide}
              warehouseExportType={warehouseExportType}
              warehouseId={warehouseId}
              isChangeRowData={isChangeRowData}
              setIsChangeRowData={setIsChangeRowData}
            />
          </Formik>
        </Modal.Body>

      </Modal>
    </div>
  );
};
export default DialogThemMoiPhieuXuatKho;
